import React from "react";
import Navbar from "./Navbar";
import HeaderBody from "./HeaderBody";
import HeaderFooter from "./HeaderFooter";

const Home = () => {
  return (
    <header>
      <Navbar />
      <HeaderBody />
      <HeaderFooter />
    </header>
  );
};

export default Home;
